export { default } from './samsung-pay';
